import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ComponentEntity} from "../../../entities/component-entity";
import {defaultVideoComponentEntity} from "../../../commons/defaults-components";
import {ClickComponentDirective} from "../../../directives/click-component.directive";
import {PositionDirective} from "../../../directives/position.directive";


@Component({
  selector: 'lib-video',
  standalone: true,
  imports: [CommonModule, ClickComponentDirective, PositionDirective],
  templateUrl: './video.component.html',
  styleUrl: './video.component.scss',
})
export class VideoComponent {
  cdkDragBoundaryName = input<string>('');
  isDragging = false;

  component = input<ComponentEntity>(defaultVideoComponentEntity());

}
